__turbopack_context__.v({
  "crumbCurrent": "ScienceBreadcrumb-module__3TUUKG__crumbCurrent",
  "crumbInert": "ScienceBreadcrumb-module__3TUUKG__crumbInert",
  "crumbLink": "ScienceBreadcrumb-module__3TUUKG__crumbLink",
  "crumbs": "ScienceBreadcrumb-module__3TUUKG__crumbs",
  "sep": "ScienceBreadcrumb-module__3TUUKG__sep",
});
